module.exports = __webpack_public_path__ + "media/images/favicon-8661012e87d39cede7f25a77bd16e170.ico";